import Vue from 'vue';
import Swiper from '@/components/swiper/Swiper.vue';
import ProductItem from '@/modules/products/containers/ProductItem.vue';
import { navigateWindow } from '@/router/routerUtils';
export default Vue.extend({
    components: { Swiper, ProductItem },
    props: {
        products: {
            type: Array,
            default: [],
        },
        title: {
            type: String,
            default: '',
        },
        isFiltered: {
            type: Boolean,
            default: false,
        },
        link: {
            type: String,
            default: '',
        },
        isViewMoreActive: {
            type: Boolean,
            default: true,
        },
        isLoading: Boolean,
    },
    data() {
        return {
            menuCategories: ['Alcohol', 'Electronics', 'Beauty', 'Others'],
            selectedCategory: '',
        };
    },
    methods: {
        changeCategory(category) {
            this.selectedCategory = category;
        },
        goToLink() {
            navigateWindow(this.link || '/');
        },
    },
});
